/** get items column */
// import { TagItemTypes } from "../../../badge-and-tag/ERP";
import { formatMoney } from "../../../../utils/util";
export const columns = ()=>{
  return [
    {
      title: "รหัสสินค้า",
      key: "stcode",
      dataIndex: "stcode", 
      width:"15%",
      sorter: (a, b) => (a?.stcode || "").localeCompare(b?.stcode || ""),
    },
    {
      title: "ชื่อสินค้า",
      dataIndex: "stname",
      key: "stname",
      sorter: (a, b) => (a?.stname || "").localeCompare(b?.stname || ""),
      // width:"25%",
    },
    {
        title: "ราคาซื้อ",
        dataIndex: "price",
        key: "price", 
        width: "10%",
        align: "right",
        className: "!pe-3",
        editable: true,
        required: true,
        type:'number',
        render: (_, rec) => <>{ formatMoney( Number(rec?.price ||  0),  2, 2 )}</>,
      },
      {
      title: "หน่วยสินค้า",
      dataIndex: "unit",
      key: "unit",
      align: "center",
      width:"15%",
    },
    {
      title: "ชนิดสินค้า",
      dataIndex: "typename",
      key: "typename",
      align: "center",
      width:"15%",
      sorter: (a, b) => (a?.typename || "").localeCompare(b?.typename || ""),
    },
  ]
};